import './App.css';
import RoutePages from './Components/RoutePages';

function App() {
  return (
    <div className="wrapper">
      <RoutePages />
    </div>
  );
}

export default App;
